export default "__VITE_ASSET__CSBFOufm__"